export const tratonPreset = {
	primitive: {
		transitionDuration: '0.1s',
	},
	components: {
		button: {
			root: {
				paddingX: '1.5rem',
				paddingY: '2rem',
			},
			colorScheme: {
				light: {
					root: {
						primary: {
							background:         '#ffffff',
							hoverBackground:    '{surface.100}',
							activeBackground:   '{surface.200}',
							borderColor:        '#1a1a19',
							hoverBorderColor:   '#1a1a19',
							activeBorderColor:  '#1a1a19',
							color:              '#1a1a19',
							hoverColor:         '#1a1a19',
							activeColor:        '#1a1a19',
						},
						contrast: {
							background:         '{primary.600}',
							hoverBackground:    '{primary.700}',
							activeBackground:   '{primary.800}',
							borderColor:        '{primary.600}',
							hoverBorderColor:   '{primary.700}',
							activeBorderColor:  '{primary.800}',
							color:              '#ffffff',
							hoverColor:         '#ffffff',
							activeColor:        '#ffffff',
						},
					},
				},
				dark: {
					root: {
						primary: {
							background:         'transparent',
							hoverBackground:    '{surface.800}',
							activeBackground:   '{surface.700}',
							borderColor:        '{surface.600}',
							hoverBorderColor:   '{surface.500}',
							activeBorderColor:  '{surface.500}',
							color:              '#d9edf0',
							hoverColor:         '#d9edf0',
							activeColor:        '#d9edf0',
						},
						contrast: {
							background:         '{primary.600}',
							hoverBackground:    '{primary.700}',
							activeBackground:   '{primary.800}',
							borderColor:        '{primary.600}',
							hoverBorderColor:   '{primary.700}',
							activeBorderColor:  '{primary.800}',
							color:              '#ffffff',
							hoverColor:         '#ffffff',
							activeColor:        '#ffffff',
						},
					},
				},
			},
		},
		progressspinner: {
			colorScheme: {
				light: {
					root: {
						colorOne: '#008294',
						colorTwo: '#66b8c4',
						colorThree: '#004852',
						colorFour: '#2d9ead',
					},
				},
				dark: {
					root: {
						colorOne: '#008294',
						colorTwo: '#66b8c4',
						colorThree: '#004852',
						colorFour: '#2d9ead',
					},
				},
			},
		},
		dialog: {
			css: ({ dt }) => `
				.p-dialog {
					min-width: ${dt('dialog.min.width')};
					max-width: ${dt('dialog.max.width')};
				}
				.p-dialog-footer {
					justify-content: ${dt('dialog.footer.justify.content')};
				}
				.p-dialog-close-button { 
					width: 6rem;
					height: 6rem;
				}
				.p-dialog-close-button svg {
					width: 3.5rem;
					height: 3.5rem;
				}
			`,
			root: {
				borderRadius: '0',
				shadow: '0 10px 30px rgba(0, 36, 41, 0.25)',
				minWidth: '160rem',
				maxWidth: '90vw',
			},
			header: {
				padding: '4rem 4rem 4rem',
				gap: '0.75rem',
			},
			title: {
				fontSize: '1.25rem',
				fontWeight: '600',
			},
			content: {
				padding: '0 4rem 1rem 4rem',
			},
			footer: {
				padding: '4rem 4rem 4rem 4rem',
				gap: '0.75rem',
				justifyContent: 'flex-start',
			},
			colorScheme: {
				light: {
					root: {
						background: '#ffffff',
						borderColor: '{primary.200}',
						color: '#1a1a19',
					},
				},
				dark: {
					root: {
						background: '{primary.950}',
						borderColor: '{primary.800}',
						color: '#d9edf0',
					},
				},
			},
		},
	},
	semantic: {
		primary: {
			50: '#f8fcfc',
			100: '#e9f5f6',
			200: '#b3dce1',
			300: '#8ccad2',
			400: '#66b8c4',
			500: '#2d9ead',
			600: '#008294',
			700: '#006371',
			800: '#004852',
			850: '#003137',
			900: '#002429',
			950: '#001d21',
			1000: '#001214',
		},
		colorScheme: {
			light: {
				text: {
					color: '#1A1A19',
				},
				surface: {
					50: '#fcfbf7',
					100: '#f6f3e9',
					150: '#ebe7dd',
					200: '#d6d4c9',
					300: '#c2bfb6',
					400: '#a6a49c',
					500: '#8c8a84',
					600: '#73716c',
					700: '#595854',
					800: '#454441',
					900: '#252423',
					950: '#1a1a19',
				},
			},
			dark: {
				primary: {
					color: '#d9edf0',
					contrastColor: '{surface.950}',
					hoverColor: '{surface.100}',
					activeColor: '{surface.200}',
				},
				content: {
					background: '{surface.950}',
					color: '#d9edf0',
				},
				navigation: {
					item: {
						color: '#d9edf0',
					},
				},
				formField: {
					background: '{surface.1000}',
					borderColor: '{surface.700}',
					hoverBorderColor: '{surface.600}',
					focusBorderColor: '{surface.600}',
					color: '#d9edf0',
					placeholderColor: '{surface.200}',
					floatLabelColor: '{surface.200}',
					floatLabelActiveColor: '{surface.200}',
					iconColor: '{surface.200}',
				},
				text: {
					color: '#d9edf0',
					mutedColor: '{surface.200}',
					hoverMutedColor: '{surface.300}',
				},
				surface: {
					50: '#f8fcfc',
					100: '#e9f5f6',
					200: '#b3dce1',
					300: '#8ccad2',
					400: '#66b8c4',
					500: '#2d9ead',
					600: '#008294',
					700: '#006371',
					800: '#004852',
					850: '#003137',
					900: '#002429',
					950: '#001d21',
					1000: '#001214',
				},
			},
		},
	},
};
